import type { DashboardPipelineOverview } from '../types';

export type OpenOfferSummary = {
  count: number;
  volume: number;
};

export type OfferAcceptance = {
  won: number;
  lost: number;
  /** Gewonnen ÷ (gewonnen + verloren), 0–1; null, solange nichts entschieden ist. */
  rate: number | null;
};

/**
 * Offene Angebote über alle Pipelines: Projekte offener Phasen mit Angebotssumme und deren Volumen.
 * Projekte ohne Angebot (z. B. Phase „Neu“) zählen nicht; ältere Server ohne offerCount liefern die
 * Projektanzahl der Phase.
 */
export function openOfferSummary(pipeline: DashboardPipelineOverview): OpenOfferSummary {
  let count = 0;
  let volume = 0;
  for (const breakdown of pipeline.byPipeline) {
    for (const phase of breakdown.phases) {
      count += phase.offerCount ?? phase.count;
      volume += phase.angebotsvolumen;
    }
  }
  return { count, volume: Math.round(volume * 100) / 100 };
}

/** Annahmequote über alle Pipelines aus den Gewonnen-/Verloren-Summen. */
export function offerAcceptance(pipeline: DashboardPipelineOverview): OfferAcceptance {
  let won = 0;
  let lost = 0;
  for (const breakdown of pipeline.byPipeline) {
    won += breakdown.won.count;
    lost += breakdown.lost.count;
  }
  const decided = won + lost;
  return { won, lost, rate: decided > 0 ? won / decided : null };
}
